// extracted by mini-css-extract-plugin
export default {"offline":"index_offline_ll7uM","offlineBox":"index_offlineBox_YO9iF","icon":"index_icon_-uJPP","btn":"index_btn_df-BD"};